import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './../../../services/API/auth/auth.service';
import { NotificationServiceService } from './../../../services/notification-service/notification-service.service';

@Injectable({
  providedIn: 'root'
})
export class SocketDiagnosticoGuard {

  constructor(
    private router: Router,
    private notificationService: NotificationServiceService,
    private authService: AuthService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.authService.isLogged()) {
      this.notificationService.openSnackBar('Tu sesión ha expirado');
      this.router.navigate(['/login']);
      return false;
    }

    if (this.authService.canAccessSocketDiagnostico()) {
      return true;
    }

    this.notificationService.openSnackBar('No tienes permiso para acceder a esta página');
    this.router.navigate(['/dashboard/settings']);
    return false;
  }

}
